<div class="container-fluid">
  <h2 class="text-center">{{ id ? 'Edit Counselling Work Update' : 'Add Work Counselling Update' }}</h2>
  <mat-card>
<!--      <prettyjson [obj]="counsellingWorkForm.value"></prettyjson>-->
    <form [formGroup]="counsellingWorkForm">
      <div class="row" >
        <div class="col-md-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Date</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="date" [max]="maxDate">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline" class="col-md-4">
          <mat-label>Counsellor Name</mat-label>
          <input matInput formControlName="counsellorName" readonly>
        </mat-form-field>
<!--        <app-searchable-select class="col-md-4"-->
<!--                               [options]="counselorName"-->
<!--                               displayKey="name"-->
<!--                               [placeholder]="'Select Counsellor Name'"-->
<!--                               [selectedValue]="{ name: counsellingWorkForm.get('counsellorName')?.value }"-->
<!--                               [label]="'Select Counsellor Name'"-->
<!--                               (selectionChange)="onCounselorSelected($event)"-->
<!--        ></app-searchable-select>-->

        <app-searchable-select
          class="col-md-4"
          [multiple]="true"
          [options]="centres$ | async"
          [selectedValue]="selectedCentre"
          [displayWithFn]="displayCentre"
          [placeholder]="'Select Centre'"
          [label]="'Select Centre'"
          (selectionChange)="onCentreSelect($event)">
        </app-searchable-select>
<!--        <app-searchable-select class="col-md-4"-->
<!--                               [options]="filteredTeachers$ | async"-->
<!--                               [selectedValue]="counsellingWorkForm.get('submittedBy')?.value"-->
<!--                               [displayWithFn]="displayTeacher"-->
<!--                               [placeholder]="'Submitted By'"-->
<!--                               [label]="'Submitted By'"-->
<!--                               (selectionChange)="onTeacherSelect($event)"-->
<!--        ></app-searchable-select>-->
        <mat-form-field appearance="outline" class="col-md-12">
          <mat-label>Task / Activities</mat-label>
          <textarea matInput rows="3" formControlName="task"></textarea>
        </mat-form-field>
        <mat-form-field *ngIf="this.userData=='Krisha Shah' || 'Vaishali Nanda'" appearance="outline" class="col-md-12">
          <mat-label>Remarks</mat-label>
          <textarea matInput rows="2" formControlName="remarks"></textarea>
        </mat-form-field>
        <div class="justify-content-center d-flex gap-2">
          <button mat-raised-button color="warn" (click)="mDialogRef.close()">Cancel</button>
          <button mat-raised-button color="primary" (click)="submit()" [disabled]="counsellingWorkForm.invalid || isLoading" >Save</button>
        </div>
      </div>
    </form>
  </mat-card>
</div>
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>

<!--<button mat-raised-button color="warn" (click)="bulkChangeObservationData()">Bulk Upload</button>-->
